/**
 * Blueprint for the pagination object.
 */
export class Pager {
  public totalItems: number;
  public currentPage: number;
  public pageSize: number;
  public totalPages: number;
  public startPage: number;
  public endPage: number;
  public startIndex: number;
  public endIndex: number;
  public pages: any;

  public constructor(pager: any) {
    this.totalItems = pager.totalItems;
    this.currentPage = pager.currentPage;
    this.pageSize = pager.pageSize;
    this.totalPages = pager.totalPages;
    this.startPage = pager.startPage;
    this.endPage = pager.endPage;
    this.startIndex = pager.startIndex;
    this.endIndex = pager.endIndex;
    this.pages = pager.pages;
  }
}
